import { theme } from "antd";

const themeBaseColor = "#FF7100";

const baseThemeConfig = {
  token: {
    fontFamily: "Roboto",
    borderRadius: 26, // Apply a global border-radius of 18px
    wireframe: false,
    colorPrimary: themeBaseColor,
    colorInfo: themeBaseColor,
    fontWeight: "bold",
    
  },
  components: {
    Menu: {
      itemHeight: 50,
      controlHeightLG: 40,
      selectedMenuItemColor: themeBaseColor,
    },
    Button: {
      primaryShadow: "none",
      color: "#000",
      defaultShadow: "none",
      defaultColor: "none",
      lineWidth: 0,
      controlHeightLG: 48,
      borderRadius: 32, // Apply a border-radius of 18px for buttons
      paddingBlockLG: 18, // Vertical padding for large buttons
      paddingInlineLG: 40, // Increased horizontal padding for large buttons (left and right)
      defaultBorderColor: themeBaseColor,
      defaultBorderWidth: 1,
    },
    Input: {
      borderRadiusLG: 18, // Border-radius of 18px for Input components
      paddingInlineLG: 18, // Suitable padding for Input components
      paddingLeft: 18, // Ensure left padding consistency
    },
    Select: {
      borderRadiusLG: 18, // Border-radius of 18px for Select components
      paddingInlineLG: 18, // Suitable padding for Select components
      paddingLeft: 18, // Ensure left padding consistency for Select
      popupMatchSelectWidth: true, // To maintain width consistency
    },
    TextArea: {
      borderRadiusLG: 18, // Border-radius of 18px for TextArea components
      paddingInlineLG: 18, // Suitable padding for TextArea components
      paddingBlockLG: 18, // Suitable vertical padding for TextArea
    },
    Autocomplete: {
      borderRadiusLG: 18, // Border-radius of 18px for Autocomplete components
      paddingInlineLG: 18, // Suitable padding for Autocomplete components
      paddingLeft: 18, // Ensure left padding consistency for Autocomplete
    },
    Checkbox: {
      borderRadiusLG: 4
    },
    Pagination: {
      itemActiveBg: "rgb(255,151,0)",
      colorPrimary: "rgb(0,0,0)",
      colorPrimaryHover: "rgb(0,0,0)",
    },
  },
};

const customDarkTheme = {
  ...baseThemeConfig,
  algorithm: theme.darkAlgorithm,
  token: {
    ...baseThemeConfig.token,
    colorBgLayout: "rgba(31, 22, 22, 1.0)",
    colorBgContainer: "rgba(39, 32, 30, 1.0)",
  },
};

const customDefaultTheme = {
  ...baseThemeConfig,
  algorithm: theme.defaultAlgorithm,
  token: {
    ...baseThemeConfig.token,
    colorBgLayout: "rgba(232, 232, 232, 0.4)",
    colorText:"#000000",
    colorBorder: '#b3b3b3',
  },
};

export { customDefaultTheme, customDarkTheme };
